import apiEndpoints from 'constants/apiEndpoints';
import { json } from 'react-router-dom';
import fetchData from 'services/fetchData';

export async function truckerUpdateLoader({ params }) {
  const { id } = params;

  try {
    const response = await fetchData(apiEndpoints.trucker.getDetail(id)); // Replace with your API endpoint
    if (!response.status) {
      throw new Response('Failed to fetch employee data', { status: 500 });
    }
    const truckerData = response.data;
    return truckerData; // Return the fetched data
  } catch (error) {
    throw json({ message: error.message }, { status: 500 });
  }
}
